export default "/static/fc44455236dc85e9.svg"